import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import './login.css';

import loginVisual from '../assets/loginvisual.png';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorVisible, setErrorVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    setLoading(true);
    setErrorVisible(false);

    const { error } = await supabase.auth.signInWithPassword({
      email: email,
      password: password,
    });

    if (error) {
      setErrorVisible(true);
      setLoading(false);
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <main className="login_page">
      <section className="login_visual">
        <img src={loginVisual} alt="Techne admin portal decorative visual" />

        <div className="login_visual_overlay">
          <p>TECHNE ADMIN</p>
          <h1>
            Manage the future
            <span> of experience.</span>
          </h1>
        </div>
      </section>

      <section className="login_panel">
        <div className="login_container">
          <div className="login_header">
            <p className="login_label">Dashboard Access</p>
            <h1 className="login_title">Welcome Back</h1>
            <p className="login_subtitle">
              Sign in to manage Techne content, bookings, startups, tickets, and updates.
            </p>
          </div>

          {errorVisible && (
            <div
              aria-live="assertive"
              className="login_error"
              role="alert"
            >
              Invalid credentials. You don't have access to this page.
            </div>
          )}

          <form aria-label="Dashboard login" className="login_form" onSubmit={handleLogin}>
            <div className="login_field">
              <label htmlFor="email">Email Address</label>
              <input
                id="email"
                type="email"
                placeholder="admin@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="login_field">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button
              aria-busy={loading}
              className="login_button"
              disabled={loading}
              type="submit"
            >
              {loading ? 'Signing In...' : 'Access Dashboard'}
            </button>
          </form>
        </div>
      </section>
    </main>
  );
};

export default Login;
